// extracted by mini-css-extract-plugin
module.exports = {"card":"LinkError_card__dVmQa","description":"LinkError_description__3crcQ"};